// Local port of the legacy usePageVisibility — scoped to the presence
// feature so the heartbeat owns its visibility source of truth.
import { useEffect, useState } from "react";

function isDocumentVisible(): boolean {
  return (
    typeof document === "undefined" || document.visibilityState !== "hidden"
  );
}

/** True while the tab is foregrounded; flips on `visibilitychange`. */
export function usePresencePageVisibility(): boolean {
  const [isVisible, setIsVisible] = useState(isDocumentVisible);
  useEffect(() => {
    const onChange = (): void => setIsVisible(isDocumentVisible());
    // Re-sync on attach: a visibilitychange can fire between the initial
    // render and this effect running, which the listener alone would miss.
    onChange();
    document.addEventListener("visibilitychange", onChange);
    return () => document.removeEventListener("visibilitychange", onChange);
  }, []);
  return isVisible;
}
